import styled, { css } from "styled-components"
import { Link } from "react-scroll"
import { LayoutContainer } from "../shared/grid"
import TextStyles, {
  desktopTextStyles,
  mobileTextStyles,
  FontFamilyRegular,
} from "../shared/typography.styles"

import Breakpoints from "../shared/breakpoints"

export const HeroContainer = styled.div`
  background-image: ${props =>
    props.backgroundImage ? `url('${props.backgroundImage}')` : "none"};
  background-size: cover;

  & > ${LayoutContainer}:nth-child(1) {
    @media (min-width: ${Breakpoints.lg}) {
      height: 768px;
    }
  }
`

export const OverlayUpper = css`
  background: var(--overlay-blue);
  mix-blend-mode: multiply;
`
export const OverlayLower = css`
  background: var(--overlay-darkgrey);
  mix-blend-mode: multiply;
`

export const HeroText = styled.h1`
  color: var(--white);
  grid-column: 2 / 12;
  ${mobileTextStyles.MobileHeadingOneRegular}
  margin-top: 104px;

  @media (min-width: ${Breakpoints.md}) {
    font-weight: 300;
    text-align: center;
    grid-column: 1 / -1;
    margin-top: 172px;
    padding: 0 2.5vw;
  }

  @media (min-width: ${Breakpoints.lg}) {
    margin-top: 294px;
    ${desktopTextStyles.HeadingOneRegular}
    font-weight: 300;
  }
`

export const SubheadingList = styled.ul`
  ${mobileTextStyles.MobileHeadingThreeRegular}

  color: var(--white);
  list-style-type: square;
  grid-column: 2 / -2;
  margin-top: 38px;
  margin-left: 18px;

  & > li {
    margin-top: 12px;

    & > span {
      padding-left: 12px;
      display: block;
    }
  }

  @media (min-width: ${Breakpoints.md}) {
    ${TextStyles.tabletTextStyles.TabletHeadingTwoRegular}
    display: flex;
    justify-content: space-between;
    grid-column: 1 / -1;
    font-size: 16px;

    justify-self: center;

    margin-top: 24px;
    margin-left: 0px;
    flex-wrap: nowrap;

    text-align: center;
    letter-spacing: 0.12em;

    color: var(--white);

    & > li {
      box-sizing: border-box;

      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }

    & > li:not(:last-child) {
      ::after {
        position: absolute;
        content: "";
        left: 4px;
        width: 100%;
        height: 8px;
        border-right: 8px solid var(--white);
      }
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingTwoRegular}
    font-size: 20px;

    max-width: 1100px;
    align-self: center;
    justify-self: center;
  }
`

export const ActionButton = styled(Link)`
  ${desktopTextStyles.HeadingThreeBold}
  cursor: pointer;
  width: 100%;
  font-size: 12px;
  line-height: 11px;
  display: flex;
  align-items: center;
  letter-spacing: 0.2em;

  background-color: var(--burnt-orange);
  color: var(--white);
  padding: 16px 48px;
  display: inline-block;
  border: none;
  outline: none;
`

export const ButtonContainer = styled.div`
  grid-column: 2 / 12;
  margin: 48px 0px 84px 0px;

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 5 / 9;

    margin: 48px 0px 207px 0px;
  }
  max-width: 275px;
  justify-self: center;
  display: flex;
  justify-content: center;
`

export const StatListItem = styled.li`
  color: var(--white);
  ${FontFamilyRegular}
  font-style: normal;
  text-transform: uppercase;
  text-align: center;

  margin: 32px 0;

  font-weight: 400;
  letter-spacing: 0.08em;

  font-size: 10px;
  line-height: 10px;

  @media (min-width: ${Breakpoints.md}) {
    margin: 24px 0;
  }

  @media (min-width: ${Breakpoints.lg}) {
    font-weight: 300;
    margin: 32px 0;
    font-size: 14px;
    line-height: 13px;
  }
`
export const StatListPlus = styled.span`
  font-size: 30px;
  line-height: 29px;
  margin-left: 5px;

  @media (min-width: ${Breakpoints.md}) {
    font-size: 16px;
    font-weight: 400;
  }
  @media (min-width: ${Breakpoints.lg}) {
    font-size: 30px;
  }
`

export const StatListNumber = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 30px;
  line-height: 29px;

  @media (min-width: ${Breakpoints.lg}) {
    font-size: 48px;
    line-height: 46px;
  }

  margin-bottom: 8px;
`

export const StatListContainer = styled.ul`
  width: 100%;
  grid-column: 1 / -1;

  display: flex;
  justify-content: space-around;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 3 / -3;
  }

  @media (min-width: ${Breakpoints.lg}) {
  }
`
